import React, { Component } from 'react';

import Thumbnail from './YoutubeThumbnail';
import YT from 'react-youtube';

const monthNameMap = {
  '01': 'Jan',
  '02': 'Feb',
  '03': 'Mar',
  '04': 'Apr',
  '05': 'May',
  '06': 'Jun',
  '07': 'Jul',
  '08': 'Aug',
  '09': 'Sep',
  '10': 'Oct',
  '11': 'Nov',
  '12': 'Desc',
};


const formatDate = (date, isFirst) => {
  const [year, month] = date.split('-');
  return (
    <div>
      <div className="month">
        {month[0] === '0' ? month[1] : month === 11 ? X : month}<br/>
      </div>
      <br/>
      { (isFirst || month === '01') && <div className="year">{year}</div> }
    </div>
  )
}

const DateColumm = ({date, ids, isFirst, onVideoPick, tnMounted }) => {
  return (
    <div className="dateColumn">
      <div className="thumbnail-container">
          { ids.map(id => <Thumbnail onMount={tnMounted} key={id} id={id} onClick={() => onVideoPick(id) }/>) }
        </div>
        <div className="date">
          { formatDate(date, isFirst) }
        </div>
    </div>
  )
}

const Player = ({ id }) => <div className="youtube"><YT videoId={id}/></div>

class YoutubeChart extends Component {
  constructor(props,...args) {
    super(props,...args)
    this.state = {
      playedId: null,
    };
    this._videoPicked = this._videoPicked.bind(this);
    this._getColumn = this._getColumn.bind(this);
    this._totalCount = this._calculateTotalCount(props.data)
    this._tnMountedCount = 0;
    this._tnMounted = this._tnMounted.bind(this);
  }
  _calculateTotalCount(data) {
    return this.props.data.reduce((total, p) => {
      return total + p.ids.length;
    }, 0)
  }
  _tnMounted() {
    this._tnMountedCount++;
    if (this._tnMountedCount == this._totalCount) {
      this.props.isReady();
    }
  }
  _videoPicked(id) {
    this.setState({
      playedId: id,
    });
  }
  _getColumn({ date, ids }, isFirst) {
    return <DateColumm tnMounted={this._tnMounted} key={date} onVideoPick={this._videoPicked} isFirst={isFirst} date={date} ids={ids}/>
  }
  _getColumns(data) {
    return data.map((r, idx) => this._getColumn(r, idx === 0));
  }
  render() {
    const { data } = this.props;
    const { playedId } = this.state;
    return (
      <div className="container">
        <div className={ playedId && 'modalOpened'} onClick={() => playedId && this._videoPicked(null)}>
          <div className="chart">
            { this._getColumns(data) }
          </div>
        </div>
        {playedId && <Player id={playedId}/>}
      </div>
    );
  }
}

export default YoutubeChart;



/** WEBPACK FOOTER **
 ** ./src/YoutubeChart.js
 **/